import {useEffect} from 'react'
import {signinSilentCallback} from '../../Authorization/authService'
import LoadingIndicator from '../Loading/index';

const SigninSilentCallBack = () => {
  useEffect(() => {
    async function signinSilent() {
      await signinSilentCallback()
    }

    signinSilent()
  }, [])

  return (
      <LoadingIndicator props={true}/>
  )
}

export default SigninSilentCallBack
